import styled from '@emotion/styled';
import { rem } from '@utils';

const Action = styled.div();

const Sidebar = styled.aside<{
  isBusy: boolean;
  isExpanded: boolean;
  isOpen: boolean;
}>(
  ({ isBusy, isOpen, isExpanded }) => `
  background: var(--sidebar-background-color);
  color: var(--sidebar-color);
  cursor: ${isBusy ? 'wait' : 'default'};
  display: flex;
  flex-direction: column;
  grid-area: c;
  width: var(
    ${isExpanded ? '--sidebar-max-width' : '--sidebar-min-width'}
  );
  padding: ${rem(16)} ${rem(isExpanded ? 16 : 14)} 0;
  position: sticky;
  top: 0;
  transition: width 200ms ease-out;
  will-change: width;
  z-index: 3;

  > * {
    pointer-events: ${isBusy ? 'none' : 'auto'};
  }

  &:focus-visible {
    outline: none;
  }

  ${Action} {
    margin: 0 ${rem(isExpanded ? 0 : -8)} ${rem(16)};
    padding: 0 ${rem(isExpanded ? 0 : 8)} ${rem(24)};
    
    .button {
      max-width: ${isExpanded ? '108px' : '32px'};
      position: relative;
      transition: max-width 100ms ease-out;
      white-space: nowrap;
      will-change: max-width;
    }

    .button-text {
      display: ${isExpanded ? 'block' : 'none'};
    }
  }

  @media (max-width: 1024px) {
    position: fixed;
    top: var(--octopus-app-bar-height, 64px);
    right: 0;
    bottom: 0;
    left: 0;
    transform: translate3d(${isOpen ? 0 : -100}%, 0, 0);
    transition: transform 250ms ease-in-out;
    width: var(--sidebar-max-width);
    will-change: transform;
    z-index: 5;

    .sidebar-collapse-button {
      display: none;
    }

    ${Action} {
      .button {
        max-width: max-content;
      }

      .button-text {
        display: block;
      }
    }
  }

`
);

const CloseButton = styled.button`
  color: var(--sidebar-color);
  background: none;
  border: none;
  cursor: pointer;
  display: none;
  position: absolute;
  top: 16px;
  right: 16px;

  &:focus-visible {
    border-radius: 1px;
    outline-offset: 4px;
    outline: 1px solid ${({ theme }) => theme.palette.common.white};
  }

  @media (max-width: 1024px) {
    display: flex;
  }
`;

const Backdrop = styled.div<{ isVisible: boolean }>`
  background: ${({ theme }) => theme.palette.common.black}88;
  position: fixed;
  top: var(--octopus-app-bar-height, 64px);
  right: 0;
  bottom: 0;
  left: 0;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
  transition: 100ms ease-in;
  width: 100vw;
  z-index: 4;
`;

const LinkMask = styled.a`
  position: absolute;
  inset: -2px;
`;

const Styled = {
  Action,
  Backdrop,
  CloseButton,
  LinkMask,
  Sidebar
};

export default Styled;
